<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-size-33">
      <application-detail-form
        ref="application-detail-form"
        header-color="green"
      ></application-detail-form>
      <application-edit-form
        ref="application-edit-form"
        @refresh="refreshApplication"
        v-if="
          application_status !== 10 &&
            application_status !== 120 &&
            application_status !== 140 &&
            application_status !== 170 &&
            application_status !== 180 &&
            application_status !== 190
        "
        header-color="green"
      ></application-edit-form>
    </div>
    <div class="md-layout-item md-medium-size-100 md-size-33">
      <application-user-form
        ref="application-user-form"
        header-color="green"
      ></application-user-form>
    </div>
    <div class="md-layout-item md-medium-size-100 md-size-33">
      <application-tables
        ref="application-tables"
        header-color="green"
      ></application-tables>
      <application-chat
        ref="application-chat"
        header-color="green"
      ></application-chat>
    </div>
  </div>
</template>
<script>
import ApplicationEditForm from "./ApplicationUpdateComponent/ApplicationEditForm";
import ApplicationUserForm from "./ApplicationUpdateComponent/ApplicationUserForm";
import ApplicationTables from "./ApplicationUpdateComponent/ApplicationTables";
import ApplicationDetailForm from "./ApplicationUpdateComponent/ApplicationDetailForm";
import ApplicationChat from "./ApplicationUpdateComponent/ApplicationChat";

export default {
  components: {
    ApplicationEditForm,
    ApplicationUserForm,
    ApplicationTables,
    ApplicationDetailForm,
    ApplicationChat
  },
  data() {
    return {
      application_status: null,
      all_status: {
        "New application": 10,
        "On process": 20,
        "Missing documents": 150,
        "Declined/Rejected": 160,
        "Offer sent": 50,
        "Waiting Final acceptance": 60,
        "Acceptance letter sent": 70,
        "Visa applied": 80,
        "Visa received": 90,
        "Visa rejected": 100,
        "Enrolled (Waiting student certificate)": 110,
        Enrolled: 120,
        "Refund requested": 130,
        Refunded: 140,
        Frozen: 170,
        Cancelled: 180,
        Dropped: 190
      }
    };
  },
  methods: {
    refreshApplication(status) {
      this.$refs["application-detail-form"].application_status = status;
      this.$refs["application-edit-form"].application_status = status;
      this.application_status = status;
      this.getApplicationLogs();
      this.getApplicationFiles();
      this.getApplicationData(false);
    },
    getApplicationLogs() {
      this.$refs["application-tables"].getLogs();
    },
    getApplicationFiles() {
      this.$refs["application-tables"].getFiles();
    },
    getApplicationData(isGetStudent) {
      this.$store
        .getApplication(this.applicationID)
        .then(response => {
          // get student user detail
          let role = 2;
          if (isGetStudent) {
            this.$store
              .getUser(role, response.data.user.id)
              .then(response => {
                this.$refs["application-user-form"].userID = response.data.id;
                this.$refs["application-user-form"].first_name =
                  response.data.first_name;
                this.$refs["application-user-form"].last_name =
                  response.data.last_name;
                this.$refs["application-user-form"].email = response.data.email;
                this.$refs["application-user-form"].gender =
                  response.data.gender;
                this.$refs["application-user-form"].mobile_phone =
                  response.data.mobile_phone;
                this.$refs["application-user-form"].picture =
                  response.data.picture;
                this.$refs["application-user-form"].country =
                  response.data.country.name;
                this.$refs["application-user-form"].date_joined =
                  response.data.date_joined;
                this.$refs["application-user-form"].info = response.data.info;
              })
              .catch(error => {
                this.$notify({
                  message: error.response.data.detail,
                  icon: "add_alert",
                  type: "warning",
                  verticalAlign: "top"
                });
              });
          }

          this.$refs["application-detail-form"].university =
            response.data.program.university;
          this.$refs["application-detail-form"].university_name =
            response.data.program.university_name;
          this.$refs["application-detail-form"].program =
            response.data.program.id;
          this.$refs["application-detail-form"].programs = [
            response.data.program
          ];
          this.$refs["application-detail-form"].type =
            response.data.program.type;
          this.$refs["application-detail-form"].education_language =
            response.data.program.education_language;
          this.$refs["application-detail-form"].education_type =
            response.data.program.education_type;
          this.$refs["application-detail-form"].season =
            response.data.season.id;
          this.$refs["application-detail-form"].seasons = [
            response.data.season
          ];
          this.$refs["application-detail-form"].price = response.data.price;
          this.$refs["application-detail-form"].partner_commission =
            response.data.partner_commission;
          this.$refs["application-detail-form"].partner_price =
            response.data.partner_price;
          this.$refs["application-detail-form"].partner_parent_commission =
            response.data.partner_parent_commission;
          this.$refs["application-detail-form"].partner_parent_price =
            response.data.partner_parent_price;
          this.$refs["application-detail-form"].currency =
            response.data.currency;
          this.$refs["application-detail-form"].commission =
            response.data.commission;
          this.$refs["application-detail-form"].commission_price =
            response.data.commission_price;
          this.$refs["application-detail-form"].fix_commission_price =
            response.data.fix_commission_price;
          this.$refs["application-detail-form"].kdv = response.data.kdv;
          this.$refs["application-detail-form"].gv = response.data.gv;
          this.$refs["application-detail-form"].scholarship_status =
            response.data.scholarship_status;
          this.$refs["application-detail-form"].code = response.data.code;
          this.$refs["application-detail-form"].uni_code =
            response.data.uni_code;
          this.$refs["application-detail-form"].student_number =
            response.data.student_number;
          this.$refs["application-detail-form"].is_apply_to_university =
            response.data.is_apply_to_university;
          this.$refs["application-detail-form"].is_approved =
            response.data.is_approved;
          this.$refs["application-detail-form"].from_application =
            response.data.from_application;

          this.$refs[
            "application-detail-form"
          ].application_status = this.all_status[
            response.data.application_status
          ];
          this.$refs[
            "application-edit-form"
          ].application_status = this.all_status[
            response.data.application_status
          ];
          this.application_status = this.all_status[
            response.data.application_status
          ];
        })
        .catch(error => {
          this.$notify({
            message: error.response.data.detail,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    }
  },
  mounted() {
    this.applicationID = this.$route.params.application_id;
    this.getApplicationData(true);
  }
};
</script>
